import { useEffect } from 'react';
import { useGetHighmarkUserProfile } from './use-get-user-profile';

export const useInjectDynatraceMetaParams = (isAuthenticated?: boolean) => {
  const { data } = useGetHighmarkUserProfile();

  useEffect(() => {
    if (data && data.customFields && isAuthenticated) {
      data.customFields.forEach(({ name, value }) => {
        const meta = document.createElement('meta');
        meta.name = name;
        meta.content = value;
        document.head.appendChild(meta);
      });
    }
  }, [data, isAuthenticated]);
};
